import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, Stack, Typography } from '@mui/material';

interface ReviewActionsBarProps {
  editedCount: number;
  submitting: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onReject: () => void;
}

export const ReviewActionsBar = ({
  editedCount,
  submitting,
  confirmDisabled,
  onConfirm,
  onReject,
}: ReviewActionsBarProps) => (
  <Stack
    spacing={1}
    alignItems="center"
    sx={{
      position: 'sticky',
      bottom: 0,
      bgcolor: 'background.paper',
      py: 2,
      mt: 2,
      borderTop: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Stack direction="row" spacing={2} justifyContent="center">
      <Button
        variant="contained"
        color="success"
        startIcon={<CheckCircleIcon />}
        disabled={submitting || confirmDisabled}
        onClick={onConfirm}
      >
        Review Changes & Confirm
      </Button>
      <Button variant="outlined" color="error" startIcon={<CancelIcon />} disabled={submitting} onClick={onReject}>
        Reject
      </Button>
    </Stack>
    {editedCount > 0 && (
      <Typography variant="body2" color="text.secondary">
        {editedCount} field{editedCount === 1 ? '' : 's'} edited
      </Typography>
    )}
  </Stack>
);
